import React from "react";
import { toolCollapseAttr, getLocale } from '@utils/util';
import { Collapse } from '@whalecloud/fdx';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import OptionSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/OptionSettings';

const { Panel } = Collapse;

const CheckBoxGroupSettings = (props: any) => {
  const messages = getLocale();

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings placeholderHide allowClearHide />
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS']} key="2">
        <OptionSettings />
      </Panel>
    </Collapse>
  );
};

export default CheckBoxGroupSettings;
